module.exports = __webpack_public_path__ + "static/media/win.772a4348.gif";